import { useState } from 'react';
import { api, ApiError, type Session } from '../api.js';

export function Auth({
  onAuthenticated,
  initialMode = 'login',
  onBack,
}: {
  onAuthenticated: (s: Session) => void;
  /** A landing manda direto para "criar conta" quando o clique foi no CTA. */
  initialMode?: 'login' | 'register';
  /** Volta para a landing — sem ele, quem clicou errado ficaria preso aqui. */
  onBack?: () => void;
}) {
  const [mode, setMode] = useState<'login' | 'register'>(initialMode);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [accountName, setAccountName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const session =
        mode === 'login'
          ? await api.login({ email, password })
          : await api.register({ email, password, name, accountName });
      onAuthenticated(session);
    } catch (cause) {
      const issues = cause instanceof ApiError ? cause.issues : undefined;
      setError(
        issues?.length
          ? issues.map((i) => i.message).join('. ')
          : cause instanceof Error
            ? cause.message
            : 'Falha ao entrar',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <form className="card auth-card" onSubmit={submit}>
        {onBack && (
          <button
            type="button"
            className="ghost"
            onClick={onBack}
            style={{ alignSelf: 'flex-start', marginBottom: 6, padding: '4px 8px' }}
          >
            ← Voltar
          </button>
        )}
        <h1>{mode === 'login' ? 'Entrar' : 'Criar conta'}</h1>
        <p className="sub">
          {mode === 'login'
            ? 'Acesse o painel de automação da sua conta.'
            : 'Cada conta é isolada: produtos, credenciais e agendamentos são só seus.'}
        </p>

        {error && <div className="notice err">{error}</div>}

        <div className="form-grid">
          {mode === 'register' && (
            <>
              <div>
                <label htmlFor="accountName">Nome da conta / empresa</label>
                <input
                  id="accountName"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                  placeholder="Minha Loja de Achadinhos"
                  required
                />
              </div>
              <div>
                <label htmlFor="name">Seu nome</label>
                <input
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </>
          )}

          <div>
            <label htmlFor="email">{mode === 'login' ? 'E-mail ou usuário' : 'E-mail'}</label>
            {/* No LOGIN o campo é texto: o admin da plataforma entra como
                "Admin", e type="email" faria o navegador exigir um "@" antes
                mesmo de enviar. No cadastro continua email — cliente sem
                e-mail não recupera senha. */}
            <input
              id="email"
              type={mode === 'login' ? 'text' : 'email'}
              autoComplete={mode === 'login' ? 'username' : 'email'}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label htmlFor="password">Senha</label>
            <input
              id="password"
              type="password"
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
            />
          </div>

          <button type="submit" className="primary" disabled={busy}>
            {busy ? <span className="spinner" /> : mode === 'login' ? 'Entrar' : 'Criar conta'}
          </button>

          <button
            type="button"
            className="ghost"
            onClick={() => {
              setMode(mode === 'login' ? 'register' : 'login');
              setError(null);
            }}
          >
            {mode === 'login' ? 'Não tenho conta ainda' : 'Já tenho conta'}
          </button>
        </div>
      </form>
    </div>
  );
}
